import Notification from 'stimulus-notification';
export default Notification;
